import { BrowserHistory, createBrowserHistory } from 'history';
import { useHistory } from 'react-router-dom';

let history = createBrowserHistory();

export default (props: any) => {
  history = useHistory();
  return props.children;
};

export const getHistory = (): BrowserHistory => history;
